import { Deserializable } from '../deserializable';

export class SearchResult<T> implements Deserializable {
  public Data: Array<T>;
  public Count: number;

  public get data(): Array<T> {
    return this.Data;
  }
  public get total(): number {
    return this.Count;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    this.Data = input.Data.map((item: T) => item);

    return this;
  }
}
